import type { PaginationInfo } from './types';

/**
 * Slices rows the caller already holds in full to the requested page.
 *
 * The paging counterpart to `sortRowsBy`: routes that page server-side answer
 * `?page=` in SQL; pages whose rows arrive whole (an aggregate report, a small
 * config list) answer it with this, so their footer counts are real.
 *
 * The page is clamped to the available range — a stale `?page=9` carried across
 * a filter change shows the last page rather than an empty grid.
 */
export function pageRowsBy<TRow>(
  rows: TRow[],
  page: number,
  perPage: number,
): { rows: TRow[]; pagination: PaginationInfo } {
  const total = rows.length;
  const totalPages = Math.max(Math.ceil(total / perPage), 1);
  const safePage = Math.min(Math.max(page, 1), totalPages);
  const start = (safePage - 1) * perPage;

  return {
    rows: rows.slice(start, start + perPage),
    pagination: { page: safePage, perPage, total, totalPages },
  };
}
